export default "../ui-bg_flat_0_aaaaaa_40x100.png";